@if(app.data().asOfUtc > 0) {
<router-outlet></router-outlet>
}
@if(spinnerService.current()) {
<mobile-spinner></mobile-spinner>
}